import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (FG110M, FG111M, FG112, FG113M, FG114, FG115)
// ============================================================

export interface FG111M {
  fg111_01: string;        // 繳款單號 (FK)
  fg111_02: number;        // 明細序號
  fg111_11: string;        // 應收帳款單號
  fg111_12: string;        // 貨款類別
  fg111_13: string;        // 款項別
  fg111_14: string;        // 票種別
  fg111_15: string;        // 廠商代碼
  fg111_16: string;        // 客戶代碼
  fg111_17: string;        // 科目代號
  fg111_171: string;       // 科目名稱
  fg111_18: string | null; // 繳款日期
  fg111_19: string;        // 幣別
  fg111_20: number;        // 外幣金額
  fg111_21: number;        // 匯率
  fg111_22: string;        // 應收帳款代號
  fg111_23: string;        // 交運單號
  fg111_24: number;        // 分攤費用
  fg111_25: string;        // 業務員
  fg111_26: string | null; // 交運日期
  fg111_27: string | null; // 開票日期
  fg111_28: string;        // 發票號碼
  fg111_29: number;        // 台幣金額
  fg111_30: string;        // 備註
  fg111_31: string;        // 銷售合約號
  fg111_32: number;        // 其他金額
  fg111_34: string;        // 預留欄位
  fg111_90: number;        // 版本號
}

export interface FG112 {
  fg112_01: string;        // 繳款單號 (FK)
  fg112_02: number;        // 明細序號
  fg112_11: string;        // 預收款單號
  fg112_12: string;        // 幣別
  fg112_13: number;        // 沖銷金額
  fg112_14: number;        // 預留整數
  fg112_90: number;        // 版本號
}

export interface FG113M {
  fg113_01: string;        // 繳款單號 (FK)
  fg113_02: number;        // 明細序號
  fg113_11: string;        // 暫借款單號
  fg113_12: string;        // 幣別
  fg113_13: number;        // 沖銷金額
  fg113_14: number;        // 預留整數
  fg113_90: number;        // 版本號
}

export interface FG114 {
  fg114_01: string;        // 繳款單號 (FK)
  fg114_02: number;        // 明細序號
  fg114_11: string;        // 代墊款單號
  fg114_12: string;        // 幣別
  fg114_13: number;        // 沖銷金額
  fg114_14: number;        // 預留整數
  fg114_90: number;        // 版本號
  fg114_91: string;        // 修改人員
  fg114_92: string | null; // 修改日期
  fg114_93: string;        // 建立人員
}

export interface FG115 {
  fg115_01: string;        // 繳款單號 (FK)
  fg115_02: number;        // 明細序號
  fg115_11: string;        // 交運單號
  fg115_12: number;        // 分攤金額
}

export interface FG110M {
  fg110_01: string;        // 繳款單號
  fg110_11: string | null; // 繳款日期
  fg110_12: number;        // 台幣繳款金額
  fg110_13: number;        // 外幣繳款金額
  fg110_14: string;        // 狀態 (N=未核准)
  fg110_15: string;        // 廠商代碼
  fg110_16: number;        // 費用分攤金額
  fg110_17: string;        // 繳款類別
  fg110_18: string;        // 過帳狀態
  fg110_19: string;        // 部門代碼
  fg110_20: string;        // 備註
  fg110_21: number;        // FG111 明細筆數
  fg110_211: number;       // FG112 筆數
  fg110_212: number;       // FG113 筆數
  fg110_214: number;       // FG114 筆數
  fg110_215: number;       // FG115 筆數
  fg110_22: number;        // 合計金額
  fg110_23: number;        // 其他金額
  fg110_24: number;        // 水單匯率
  fg110_25: string;        // 幣別
  fg110_26: string;        // 公司代碼
  fg110_27: string;        // 匯入款單號
  fg110_28: string;        // 票款別
  fg110_29: string;        // 款項別
  fg110_30: number;        // 單據類別
  fg110_32: string | null; // 登錄日期
  fg110_80: string;        // 核准旗標
  fg110_801: string;       // 核准人員
  fg110_802: string | null; // 核准日期
  fg110_803: string;       // 核准時間
  fg110_81: string;        // 沖銷旗標
  fg110_811: string;       // 沖銷人員
  fg110_812: string | null; // 沖銷日期
  fg110_813: string;       // 沖銷時間
  fg110_90: number;        // 版本號
  fg110_91: string;        // 修改人員
  fg110_92: string | null; // 修改日期
  fg110_93: string;        // 建立人員
  details?: FG111M[];
  writeoff_adv?: FG112[];
  writeoff_borr?: FG113M[];
  writeoff_adv2?: FG114[];
  alloc_fee?: FG115[];
}

export interface CreateRequest {
  master: FG110M;
  details: FG111M[];
  writeoff_adv: FG112[];
  writeoff_borr: FG113M[];
  writeoff_adv2: FG114[];
  alloc_fee: FG115[];
}

export interface ListResponse {
  data: FG110M[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

export interface ApprovalResponse {
  id: string;
  action: string;
  old_status: string;
  new_status: string;
  message: string;
}

export interface ApprovalHistory {
  id: number;
  document_no: string;
  action: string;
  actor_id: string;
  actor_name: string;
  comment: string;
  old_status: string;
  new_status: string;
  created_at: string;
}

// ============================================================
// API Methods
// ============================================================

export const pwg201Api = {
  list(page = 1, pageSize = 20): Promise<ListResponse> {
    return apiClient.get('/api/pwg201', { params: { page, pageSize } }).then(r => r.data);
  },

  get(id: string): Promise<FG110M> {
    return apiClient.get(`/api/pwg201/${id}`).then(r => r.data);
  },

  create(req: CreateRequest): Promise<FG110M> {
    return apiClient.post('/api/pwg201', req).then(r => r.data);
  },

  update(id: string, req: CreateRequest): Promise<FG110M> {
    return apiClient.put(`/api/pwg201/${id}`, req).then(r => r.data);
  },

  delete(id: string): Promise<void> {
    return apiClient.delete(`/api/pwg201/${id}`).then(() => undefined);
  },

  // Approval workflow
  submitForApproval(id: string, comment?: string): Promise<ApprovalResponse> {
    return apiClient.post(`/api/pwg201/${encodeURIComponent(id)}/submit`, { comment: comment || '' }).then(r => r.data);
  },

  approve(id: string, comment?: string): Promise<ApprovalResponse> {
    return apiClient.post(`/api/pwg201/${encodeURIComponent(id)}/approve`, { comment: comment || '' }).then(r => r.data);
  },

  reject(id: string, comment?: string): Promise<ApprovalResponse> {
    return apiClient.post(`/api/pwg201/${encodeURIComponent(id)}/reject`, { comment: comment || '' }).then(r => r.data);
  },

  writeoff(id: string, comment?: string): Promise<ApprovalResponse> {
    return apiClient.post(`/api/pwg201/${encodeURIComponent(id)}/writeoff`, { comment: comment || '' }).then(r => r.data);
  },

  getApprovalHistory(id: string): Promise<ApprovalHistory[]> {
    return apiClient.get(`/api/pwg201/${encodeURIComponent(id)}/approval-history`).then(r => r.data.data || []);
  },
};
